import { log } from "./logging";

let permissionStatus: NotificationPermission;

export const requestNotificationPermission = async (): Promise<void> => {
    permissionStatus = await Notification.requestPermission();
    log.info(`Notification permission: ${permissionStatus}`)
}

export const showNotification = (title: string, body: string) => {
    if (permissionStatus !== "denied") {
        const notification: Notification = new Notification(title, { body });
    }
}